"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMAIL_PROVIDERS = void 0;
var EMAIL_PROVIDERS = {
  DEFAULT: 'default',
  GOOGLE: 'google',
  OUTLOOK: 'outlook',
  DKIM: 'dkim'
};
exports.EMAIL_PROVIDERS = EMAIL_PROVIDERS;